"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoMarkerTypeSchemaSchema = void 0;
exports.VideoMarkerTypeSchemaSchema = {
    "$id": "https://www.redbull.com/schemas/types/video-marker.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "VideoMarkerTypeSchema",
    "description": "Meta schema for generic jsonapi type definition",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "id": {
            "type": "string",
            "pattern": "^(rrn(:([a-z\\-]+)))(:[a-zA-Z0-9\\d\\-_]+)?(:([\\d]+))?$"
        },
        "type": {
            "type": "string",
            "enum": [
                "rrn:types:video-marker"
            ]
        },
        "attributes": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
                "examples": {
                    "type": "array",
                    "items": {
                        "type": "object"
                    }
                },
                "displayName": {
                    "type": "string",
                    "pattern": "^[A-Za-z0-9]+$"
                },
                "description": {
                    "type": "string"
                },
                "schema": {
                    "type": "object",
                    "properties": {
                        "properties": {
                            "description": "Those are the properties of the schema",
                            "type": "object",
                            "properties": {
                                "additionalProperties": true,
                                "type": {
                                    "type": "object",
                                    "properties": {
                                        "additionalProperties": false,
                                        "type": {
                                            "type": "string",
                                            "enum": [
                                                "string"
                                            ]
                                        }
                                    }
                                },
                                "attributes": {
                                    "type": "object",
                                    "properties": {
                                        "additionalProperties": true,
                                        "properties": {
                                            "patternProperties": {
                                                "^[a-zA-Z]+$": {
                                                    "type": "object",
                                                    "properties": {
                                                        "displayName": {
                                                            "type": "string",
                                                            "pattern": "^[A-Za-z0-9]+$"
                                                        }
                                                    },
                                                    "examples": [
                                                        {
                                                            "url": {
                                                                "type": "string",
                                                                "displayName": "VideoLink"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        }
                                    },
                                    "examples": [
                                        {
                                            "schema": null,
                                            "type": "object",
                                            "properties": {
                                                "type": {
                                                    "type": "string",
                                                    "enum": [
                                                        "example"
                                                    ]
                                                },
                                                "attributes": {
                                                    "type": "object",
                                                    "properties": {
                                                        "url": {
                                                            "type": "string",
                                                            "displayName": "Example",
                                                            "pattern": "examplePattern"
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    ]
                                }
                            },
                            "required": [
                                "type"
                            ]
                        }
                    },
                    "required": [
                        "properties"
                    ]
                },
                "attributes": {
                    "type": "object",
                    "additionalProperties": false,
                    "patternProperties": {
                        "^[a-zA-Z]+$": {
                            "type": "object",
                            "additionalProperties": false,
                            "properties": {
                                "type": {
                                    "type": "array",
                                    "items": {
                                        "anyOf": [
                                            {
                                                "type": "string",
                                                "format": "uri"
                                            },
                                            {
                                                "type": "string",
                                                "enum": [
                                                    "boolean",
                                                    "integer",
                                                    "number",
                                                    "string"
                                                ]
                                            }
                                        ]
                                    },
                                    "minItems": 1
                                },
                                "description": {
                                    "type": "string"
                                },
                                "deprecated": {
                                    "type": "string",
                                    "enum": [
                                        "warn",
                                        "no-write"
                                    ]
                                },
                                "enum": {
                                    "type": "array"
                                },
                                "multiple": {
                                    "type": "boolean"
                                },
                                "required": {
                                    "type": "boolean"
                                },
                                "pattern": {
                                    "type": "string"
                                }
                            },
                            "required": [
                                "type"
                            ]
                        }
                    }
                },
                "relationships": {
                    "type": "object",
                    "patternProperties": {
                        "^[a-zA-Z]+$": {
                            "type": "object",
                            "additionalProperties": false,
                            "properties": {
                                "type": {
                                    "type": "array",
                                    "items": {
                                        "type": "string",
                                        "format": "uri"
                                    },
                                    "minItems": 1
                                },
                                "description": {
                                    "type": "string"
                                },
                                "calculated": {
                                    "type": "boolean"
                                },
                                "deprecated": {
                                    "type": "string"
                                },
                                "multiple": {
                                    "type": "boolean"
                                },
                                "required": {
                                    "type": "boolean"
                                }
                            },
                            "required": [
                                "type"
                            ]
                        }
                    }
                },
                "deprecated": {
                    "type": "string"
                }
            },
            "required": [
                "displayName"
            ]
        },
        "relationships": {
            "type": "object",
            "properties": {
                "groups": {
                    "type": "object",
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "properties": {
                                    "id": {
                                        "type": "string",
                                        "pattern": "^(rrn(:([a-z\\-]+)))(:[a-zA-Z0-9\\d\\-_]+)?(:([\\d]+))?$"
                                    },
                                    "type": {
                                        "type": "string",
                                        "pattern": "^(rrn(:([a-z\\-]+)))"
                                    }
                                }
                            }
                        }
                    }
                },
                "inherits": {
                    "type": "object",
                    "properties": {
                        "data": {
                            "type": "array",
                            "items": {
                                "type": "object",
                                "properties": {
                                    "id": {
                                        "type": "string"
                                    },
                                    "type": {
                                        "type": "string",
                                        "enum": [
                                            "rrn:types:video-marker"
                                        ]
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        "meta": {
            "type": "object",
            "additionalProperties": false,
            "patternProperties": {
                "^[a-zA-Z]+$": {
                    "type": "object",
                    "additionalProperties": false,
                    "properties": {
                        "type": {
                            "type": "array",
                            "items": {
                                "anyOf": [
                                    {
                                        "type": "string",
                                        "enum": [
                                            "boolean",
                                            "integer",
                                            "number",
                                            "object",
                                            "string"
                                        ]
                                    }
                                ]
                            },
                            "maxItems": 1,
                            "minItems": 1
                        },
                        "description": {
                            "type": "string"
                        },
                        "calculated": {
                            "type": "boolean"
                        },
                        "deprecated": {
                            "type": "string"
                        },
                        "enum": {
                            "type": "array"
                        },
                        "multiple": {
                            "type": "boolean"
                        }
                    },
                    "required": [
                        "type"
                    ]
                }
            }
        }
    },
    "required": [
        "id",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,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